import { render, staticRenderFns } from "./PaymentProvidersSettings.vue?vue&type=template&id=3f8f1945&scoped=true&"
import script from "./PaymentProvidersSettings.vue?vue&type=script&lang=ts&"
export * from "./PaymentProvidersSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentProvidersSettings.vue?vue&type=style&index=0&id=3f8f1945&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8f1945",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
